{
  "research": "Опитування:",
  "researchNew": "Призначити нове опитування",
  "researchNewSuccess": "Нове опитування успішно створено",
  "researchNewError": "Не вдалося призначити нове опитування",
  "table": {
    "scale": "Шкала",
    "sphere": "Сфера",
    "download": "Завантажити PDF",
    "hide": "Згорнути",
    "show": "Розгорнути",
    "empty": "Шкала не надавалась"
  },
  "dialog": {
    "scorePlural": {
      "one": "Бал",
      "few": "Бали",
      "many": "Балів"
    },
    "close": "Закрити",
    "scoreDesc": "Шкала оцінюється від 0 до 100 балів: що вищий показник, то більш вираженими є відповідні прояви.",
    "scaleMeaning": "Що означає шкала?",
    "resultMeaning": "Що означає результат?"
  }
}
